/* @flow */
import React from 'react';
// $FlowIgnore
import { MdAccountCircle } from 'react-icons/md';

export default function CaseIcon({
  style
}: Object): React.Element {
  return <MdAccountCircle style={{color: 'orange', ...style}} />;
}
